"use strict";
/*
 * Created on 17. 7. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var OptimalMarginGraphData_1 = require("./OptimalMarginGraphData");

var OptimizationScenarioData_1 = require("./OptimizationScenarioData");

var StrategyGraphData_1 = require("./StrategyGraphData");
/**
 * Data for optimization graph (LOG-3113) with point values in percents.
 * @author Radek Beran
 */


var OptimizationGraphData =
/*#__PURE__*/
function (_OptimizationScenario) {
  _inherits(OptimizationGraphData, _OptimizationScenario);

  /**
   * @param points List of all points to draw an optimization graph based on average margin in %. Average margin is the X-axis; profit,
   *        revenue, quantity hold absolute values for the Y-axis (3 graphs).
   * @param pointsInPercent list of all points normalized to percents to draw strategy graph based on average margin in % with Y values
   *        in percents. Average margin is the X-axis; profit, revenue, quantity hold percents for the Y-axis (3 graphs).
   * @param actualData Current setting of profit, revenue and quantity
   * @param optimalMargins List of optimal margins for individual optimization goals suggested by the optimization engine.
   */
  function OptimizationGraphData(points, pointsInPercent, actualData, // nullable since API change in LOG-5531
  optimalMargins) {
    var _this;

    _classCallCheck(this, OptimizationGraphData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimizationGraphData).call(this, points, actualData, optimalMargins));
    _this.points = points;
    _this.pointsInPercent = pointsInPercent;
    _this.actualData = actualData;
    _this.optimalMargins = optimalMargins;
    return _this;
  }

  return OptimizationGraphData;
}(OptimizationScenarioData_1.OptimizationScenarioData);

exports.OptimizationGraphData = OptimizationGraphData;

OptimizationGraphData.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(OptimizationGraphData.name);
  return {
    points: builder.listOf(builder.obj('points', StrategyGraphData_1.StrategyGraphData.schema, function (mat) {
      return new StrategyGraphData_1.StrategyGraphData(mat.profit, mat.revenue, mat.quantity, mat.margin);
    })),
    pointsInPercent: builder.listOf(builder.obj('pointsInPercent', StrategyGraphData_1.StrategyGraphData.schema, function (mat) {
      return new StrategyGraphData_1.StrategyGraphData(mat.profit, mat.revenue, mat.quantity, mat.margin);
    })),
    actualData: builder.opt(builder.obj('actualData', StrategyGraphData_1.StrategyGraphData.schema, function (mat) {
      return new StrategyGraphData_1.StrategyGraphData(mat.profit, mat.revenue, mat.quantity, mat.margin);
    })),
    optimalMargins: builder.listOf(builder.obj('optimalMargins', OptimalMarginGraphData_1.OptimalMarginGraphData.schema, function (mat) {
      return new OptimalMarginGraphData_1.OptimalMarginGraphData(mat.optimizationGoal, mat.margin);
    }))
  };
}();